import { IExportPromoProductsRepository, IExportPromoProductsRequest } from "@/core/repositories/export/export.promoProducts";

export class ExportPromoProductsUseCase {
  constructor(private readonly exportPromoProductsRepository: IExportPromoProductsRepository) {}

  async execute(body: IExportPromoProductsRequest): Promise<{ signedUrl: string; success: boolean }> {
    return this.exportPromoProductsRepository.exportPromoProducts(body);
  }
}
